<template>
  <b-container id="StepsInTM">
    <b-row>
      <b-col class="text-center">
        <h2 class="title">6 Steps in the TorchMetrics System</h2>
      </b-col>
    </b-row>
    <b-tabs v-model="tabIndex" content-class="mt-3" align="center" align-v="center" class="text-center">
      <b-tab active @click="linkClass(0)" class="panel-0">
        <template #title>
          <div>1</div></b-spinner>Choose <br/>a Survey
        </template>
        <b-row class="h-100 text-left content" align-v="center">
          <b-col class="col-12 col-md-6 banner-left">
            <h3>Choose a Survey</h3>
            <ul class="list-unstyled">
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                Specific presentation feedback
              </p>
            </b-media>
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                General feedback on presentation
              </p>
            </b-media>
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                Customized surveys
              </p>
            </b-media>
          </ul>
          </b-col>
          <b-col class="col-12 col-md-6 banner-left">
            <div class="card-content">
              <div class="step">
                <img src="/img/how-it-works/step1-1.png" />
              </div>
              <div class="symbol">
                <img src="/img/how-it-works/survey-type-01.png" />
              </div>
              <div class="card-image">
                <img src="/img/how-it-works/screen-pick-survey-1.png" />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab @click="linkClass(1)" class="panel-1">
        <template #title>
          <div>2</div></b-spinner>Send Link <br/>to Survey
        </template>
        <b-row class="h-100 text-left content" align-v="center">
          <b-col class="col-12 col-md-6 banner-left">
            <h3>Send Link to Survey</h3>
            <ul class="list-unstyled">
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                Send to specific individuals, team or entire company
              </p>
            </b-media>
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                Send from email or a link
              </p>
            </b-media>
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                16 to 29 questions
              </p>
            </b-media>
          </ul>
          </b-col>
          <b-col class="col-12 col-md-6 banner-left">
            <div class="card-content">
              <div class="step">
                <img src="/img/how-it-works/step2.png" />
              </div>
              <div class="symbol">
                <img src="/img/how-it-works/survey-describe-02.png" />
              </div>
              <div class="card-image">
                <img src="/img/how-it-works/screen-send-survey-01-1-1.png" />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab @click="linkClass(2)" class="panel-2">
        <template #title>
          <div>3</div></b-spinner>People <br/>Take Survey
        </template>
        <b-row class="h-100 text-left content" align-v="center">
          <b-col class="col-12 col-md-6 banner-left">
            <h3>People Take Survey</h3>
            <ul class="list-unstyled">
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                Highlights strengths and weaknesses
              </p>
            </b-media>
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                Option to write in comments
              </p>
            </b-media>
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                2 – 3 minutes to complete — easy and engaging
              </p>
            </b-media>
          </ul>
          </b-col>
          <b-col class="col-12 col-md-6 banner-left">
            <div class="card-content">
              <div class="step">
                <img src="/img/how-it-works/step3.png" />
              </div>
              <div class="card-image">
                <img src="/img/how-it-works/screen-people-take-survey.png" />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab @click="linkClass(3)" class="panel-3">
        <template #title>
          <div>4</div></b-spinner>Review <br/>Metrics
        </template>
        <b-row class="h-100 text-left content" align-v="center">
          <b-col class="col-12 col-md-6 banner-left">
            <h3>Review Metrics</h3>
            <ul class="list-unstyled">
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                Survey results tabulated into easy-to-understand metrics
              </p>
            </b-media>
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                Results in these four skill areas: <br />content, visuals, delivery, connection
              </p>
            </b-media>
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                Highlights strengths and weaknesses
              </p>
            </b-media>
          </ul>
          </b-col>
          <b-col class="col-12 col-md-6 banner-left">
            <div class="card-content">
              <div class="step">
                <img src="/img/how-it-works/step4-1.png" />
              </div>
              <div class="symbol">
                <img src="/img/how-it-works/review-92-percent.png" />
              </div>
              <div class="card-image">
                <img src="/img/how-it-works/review-metrics-bg.png" />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab @click="linkClass(4)" class="panel-4">
        <template #title>
          <div>5</div></b-spinner>Complete <br/>Action Steps
        </template>
        <b-row class="h-100 text-left content" align-v="center">
          <b-col class="col-12 col-md-6 banner-left">
            <h3>Complete Action Steps</h3>
            <ul class="list-unstyled">
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                Provides three ways to improve your skills for each question
              </p>
            </b-media>
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                Prioritizes what action steps you should do first
              </p>
            </b-media>
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                Offers multiple formats for different learning styles
              </p>
            </b-media>
          </ul>
          </b-col>
          <b-col class="col-12 col-md-6 banner-left">
            <div class="card-content">
              <div class="step">
                <img src="/img/how-it-works/step5.png" />
              </div>
              <div class="card-image">
                <img src="/img/how-it-works/screen-action-steps-1.png" />
                <button class="TMGeneralButton yellow do-it-button"><b>DO IT!</b></button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab @click="linkClass(5)" class="panel-5">
        <template #title>
          <div>6</div></b-spinner>Track Progress <br/>With Dashboard
        </template>
        <b-row class="h-100 text-left content" align-v="center">
          <b-col class="col-12 col-md-6 banner-left">
            <h3>Track Progress With Dashboard</h3>
            <ul class="list-unstyled">
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                Compares metrics from one presentation to the next
              </p>
            </b-media>
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                Tracks improvement on each question
              </p>
            </b-media>
            <b-media tag="li">
              <template #aside>
                <font-awesome-icon icon="angle-right" class="icon-list" />
              </template>
              <p class="mb-0">
                Allows you to identify if steps need to be repeated
              </p>
            </b-media>
          </ul>
          </b-col>
          <b-col class="col-12 col-md-6 banner-left">
            <div class="card-content">
              <div class="step">
                <img src="/img/how-it-works/step6-1.png" />
              </div>
              <div class="symbol">
                <img src="/img/how-it-works/track-progress-graph-02.png" />
              </div>
              <div class="card-image">
                <img src="/img/how-it-works/track-progress-dashboard-bg-1.png" />
              </div>
            </div>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
    <div class="tabs-dots">
      <div v-for="(dot, index_dot) in dots" :key="index_dot" @click="handleIndexSlide(index_dot)" class="dot" :class="index_dot === activeIndex && 'active'">
        <div />
      </div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "StepInTM",
  data() {
    return {
      dots: [],
      activeIndex: 0,
      tabIndex: 0,
    };
  },
  methods: {
    linkClass(idx) {
      return (this.activeIndex = idx);
    },
    handleIndexSlide(idx) {
      this.tabIndex = idx;
      this.activeIndex = idx;
    },
  },
  mounted() {
    this.dots = [1, 2, 3, 4, 5, 6];
    this.tabIndex = 0;
    this.activeIndex = 0;
  },
};
</script>

<style lang="less" >
@import "../../assets/components/howItWorks/StepsInTM.less";
</style>;
